import { format } from 'date-fns'

export const DateTimeFormatter = (date: string) => {
  if (!date) {
    return ''
  }
  return format(new Date(date), 'dd-MM-yyyy HH:mm:ss')
}
